const sportTypeConfig = {
    Soccer: 1,
    Basketball: 2,
    Tennis: 5,
    Cricket: 50,
};

export default sportTypeConfig;
